import React from 'react';

export default function RegisterConfirmation () {
        return (
            <div className="homeContainer">
                <div className="homeWelcomeContent">
                    <h1>
                       Check Your Email
                    </h1>
                    <p> We have sent a special link to your email. Please check your email and click the link to continue creating your account.</p>
               <p>If you do not see the email after a few minutes, please check your spam or junk folder. If you still do not see the email, please contact us and we will be happy to assist you in completing the process.</p>
                </div>
            </div>
        )
}


